import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MessageSquareText } from "lucide-react";

export const MobileCTA = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const update = () => setVisible(window.scrollY > 560);
    update();
    const lenis = window.__lenis;
    const onLenis = (e) => setVisible((e?.scroll ?? window.scrollY) > 560);
    if (lenis?.on) lenis.on("scroll", onLenis);
    window.addEventListener("scroll", update, { passive: true });
    const iv = setInterval(update, 400);
    return () => {
      if (lenis?.off) lenis.off("scroll", onLenis);
      window.removeEventListener("scroll", update);
      clearInterval(iv);
    };
  }, []);

  const go = () => {
    if (location.pathname === "/kontakt") {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: false });
      window.scrollTo(0, 0);
    } else {
      navigate("/kontakt");
    }
  };

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/90 p-3 backdrop-blur-xl transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <button
        data-testid="mobile-sticky-cta-button"
        onClick={go}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-950 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-brand-950/30"
      >
        <MessageSquareText className="h-4 w-4" />
        Kontakt Juris
      </button>
    </div>
  );
};

export default MobileCTA;
